import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// API séparée pour les paiements car l'URL de base est différente
export const paiementApi = createApi({
  reducerPath: "paiementApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API_URL?.replace('/api/v1/', ''), // Enlever /api/v1/ pour avoir juste http://127.0.0.1:8000
    credentials: 'include',
    prepareHeaders: (headers) => {
      // Récupérer le token depuis localStorage
      const token = localStorage.getItem('auth_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    createCheckout: build.mutation({
      query(body) {
        return {
          url: `/aapi/wave/checkout`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Paiements"],
    }),
    getPaymentHistory: build.query({
      query: () => `/api/v1/payments/parents/`,
      providesTags: ["Paiements"],
    }),
  }),
  tagTypes: ["Paiements"],
});

export const {
  useCreateCheckoutMutation,
  useGetPaymentHistoryQuery,
} = paiementApi;
